<template>
  <div id="wrap-content">
    <div class="back" />
    <div class="hua" />
    <div class="jinianbei" />
    <img src="./img/text.png" class="text" />
    <img src="./img/text2.png" class="text2" />
    <div class="text3">
      <div>
        {{ text1 }}
      </div>
    </div>
    <div class="text5">
      <div>
        {{ text2 }}
      </div>
    </div>
    <Top-Title :color="'black'" />
    <div class="zhijing">
      <div
        class="mingpai"
        @click="handlehref('sunword')"
        @mouseenter="handleHover('zj', true)"
        @mouseleave="handleHover('zj', false)"
      />
      <div class="jinhua">
        <div class="lazhu-werp">
          <div class="round1 round" />
          <div class="round2 round" />
          <div class="round3 round" />
        </div>
      </div>
    </div>
    <div class="zhuishi">
      <div
        class="mingpai"
        @click="handlehref('searchheros')"
        @mouseenter="handleHover('zs', true)"
        @mouseleave="handleHover('zs', false)"
      />
      <div class="lazhu">
        <div class="lazhu-werp">
          <div class="round1 round" />
          <div class="round2 round" />
          <div class="round3 round" />
        </div>
      </div>
    </div>
    <div class="hualan" @click="hrafUrl" />
    <div class="butimg" />
    <div v-show="false" class="qingming" @click="handleQingming">
      <div class="qingmingimg">守护·2021清明祭英烈</div>
      <div class="arrow" />
    </div>
  </div>
</template>
<script>
import { getMasssacrifice, getFlower } from "@/api/home.js";
export default {
  name: "Home",
  data() {
    return {
      show: false,
      text1: "每一次对英烈的仰望，都是一次叩问人生意义的自我觉醒",
      text2: "每一次对英烈的缅怀，都是一次砥砺责任使命的郑重宣誓"
    };
  },
  mounted() {
    // let ele = $(".text2");
    // console.log(ele);
    // setTimeout(() => {
    //   ele.addClass("opacity");
    // }, 2000);
  },
  methods: {
    handleQingming() {
      window.open("http://yinglie.chinamartyrs.gov.cn/21qm/#/home");
    },
    // 群体祭扫接口
    handleshow(val) {
      this.ccz = true;
      this.ccztext = true;
    },
    hrafUrl() {
      getFlower()
        .then(res => {
          console.log("进献花篮");
        })
        .catch(() => {});
      window.open("http://www.chinamartyrs.gov.cn/x_jnjsx/x_jidianchahua/");
    },
    handleHover(val, bl) {
      if (bl) {
        if (val == "zj") {
          $(".text3").css("opacity", 0);
        } else {
          $(".text5").css("opacity", 0);
        }
      } else {
        $(".text3,.text5").css("opacity", 0);
      }
    },

    handlehref(url) {
      if (url == "sunword") {
        getMasssacrifice()
          .then(res => {
            console.log(res);
          })
          .catch(() => {});
      }
      const routetele = this.$router.resolve({
        path: `/${url}`
      });
      window.open(routetele.href, "_blank");
    }
  }
};
</script>
<style lang="scss" type="text/scss" scoped>
// @import "index.scss";;
// @include animation(opacity, 1.5s, 0s);
// @include backimg(back, png);
// @include backbdimg(back, png);
#wrap-content {
  position: relative;
  width: 100%;
  height: 100%;
  // @include backbdimg("backpng", ".png");
  .back {
    width: 1920px;
    height: 100%;
    position: absolute;
    right: 0;
    bottom: 0;
    @include backbdimg("hua", ".jpg");
  }
  .jinianbei {
    height: 903px;
    width: 625px;
    position: absolute;
    right: 0;
    bottom: 0;
    @include backbdimg("jinianbei1", ".png");
  }
  .text {
    width: 661px;
    position: absolute;
    right: 455px;
    bottom: 337px;
    @include animation(opacity, 5s, 0s);
  }
  .text2 {
    opacity: 0;
    width: 313.5px;
    position: absolute;
    right: 847px;
    bottom: 355px;
    @include animation(opacity, 3s, 1s);
  }
  .text3 {
    padding-left: 12px;
    padding-top: 10px;
    box-sizing: border-box;
    opacity: 0;
    width: 39px;
    height: 437px;
    position: absolute;
    left: 125px;
    bottom: 280px;
    @include backbdimg("konghao", ".png");
    div {
      width: 20px;
      font-size: 12px;
      color: #fff;
      line-height: 17px;
    }
  }
  .text5 {
    padding-left: 12px;
    padding-top: 10px;
    box-sizing: border-box;
    opacity: 0;
    width: 39px;
    height: 437px;
    position: absolute;
    left: 318px;
    bottom: 280px;
    @include backbdimg("konghao", ".png");
    div {
      width: 20px;
      font-size: 12px;
      color: #fff;
      line-height: 17px;
    }
  }
  .zhijing {
    opacity: 0;
    position: absolute;
    z-index: 1000;
    left: 125px;
    bottom: 50px;
    @include animation(cloud-B, 2s, 1s);
    .mingpai {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 61.5px;
      height: 198.5px;
      @include backbdimg("zhijing", ".png");
      cursor: pointer;
      &:hover {
        bottom: 10px;
      }
    }
    .jinhua {
      position: absolute;
      left: 45px;
      bottom: 17px;
      width: 90px;
      height: 137px;
      @include backbdimg("jinghua", ".png");
      .lazhu-werp {
        position: absolute;
        left: 7px;
        top: 0px;
        .round {
          position: absolute;
          left: 0;
          top: 0;
          width: 78px;
          height: 78px;
          border-radius: 100%;
          opacity: 0;
          animation: kuosan1 3s linear infinite;
          border: 7px #ffb07d solid;
          animation-duration: 3s;
          animation-timing-function: linear;
          animation-delay: 0s;
          animation-iteration-count: infinite;
          animation-direction: normal;
          animation-fill-mode: none;
          animation-play-state: running;
          animation-name: kuosan1;
        }
        .round2 {
          -webkit-animation-delay: 950ms !important;
          -moz-animation-delay: 950ms !important;
          animation-delay: 950ms !important;
        }
        .round3 {
          -webkit-animation-delay: 1900ms !important;
          -moz-animation-delay: 1900ms !important;
          animation-delay: 1900ms !important;
        }
      }
    }
  }
  .zhuishi {
    opacity: 0;
    position: absolute;
    z-index: 1000;
    left: 318px;
    bottom: 50px;
    @include animation(cloud-B, 2s, 1s);
    .mingpai {
      cursor: pointer;
      position: absolute;
      left: 0;
      bottom: 0;
      width: 61.5px;
      height: 198.5px;
      @include backbdimg("zhuishi", ".png");
      &:hover {
        bottom: 10px;
      }
    }
    .round {
      position: absolute;
      left: 0;
      top: 0;
      width: 78px;
      height: 78px;
      border-radius: 100%;
      opacity: 0;
    }
    .lazhu {
      position: absolute;
      left: 35px;
      bottom: 0;
      width: 113px;
      height: 170px;
      @include backbdimg("lazu_", ".png");
      .lazhu-werp {
        position: absolute;
        left: 7px;
        top: 0px;
        .round {
          animation: kuosan1 3s linear infinite;
          border: 7px #ffb07d solid;
          animation-duration: 3s;
          animation-timing-function: linear;
          animation-delay: 0s;
          animation-iteration-count: infinite;
          animation-direction: normal;
          animation-fill-mode: none;
          animation-play-state: running;
          animation-name: kuosan1;
        }
        .round2 {
          -webkit-animation-delay: 950ms !important;
          -moz-animation-delay: 950ms !important;
          animation-delay: 950ms !important;
        }
        .round3 {
          -webkit-animation-delay: 1900ms !important;
          -moz-animation-delay: 1900ms !important;
          animation-delay: 1900ms !important;
        }
      }
    }
  }
  .hualan {
    width: 61.5px;
    height: 198.5px;
    opacity: 0;
    position: absolute;
    z-index: 1000;
    left: 511px;
    bottom: 50px;
    @include backbdimg("hualan", ".png");
    @include animation(cloud-B, 2s, 1s);
    cursor: pointer;
    &:hover {
      bottom: 60px;
    }
  }
  .butimg {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 1920px;
    height: 540px;
    @include backbdimg("butimg", ".png");
  }
  .qingming {
    transition: 1s all;
    position: absolute;
    left: 880px;
    bottom: 80px;
    width: 530px;
    height: 110px;
    cursor: pointer;
    @include backbdimg("btnbk", ".png");
    @include animation(opacity, 3s, 0s);
    .qingmingimg {
      position: absolute;
      width: 90%;
      height: 80%;
      left: 5%;
      top: 10%;
      background-color: #eb4133;
      font-family: "楷体";
      color: #fff;
      font-size: 35px;
      text-align: center;
      line-height: 85px;
      &:hover {
        opacity: 0.7;
      }
    }
    .arrow {
      width: 40px;
      height: 40px;
      position: absolute;
      top: 35px;
      left: 40px;
      background: url("img/curpin.png") no-repeat;
      background-size: 100% 100%;
      z-index: 10000000;
      animation: myfirst 2s linear 1s infinite alternate;
    }
  }
}
@-moz-keyframes kuosan1 {
  0% {
    -moz-transform: scale(0);
    transform: scale(0);
    opacity: 1;
  }
  100% {
    -moz-transform: scale(1.2);
    transform: scale(1.2);
    opacity: 0;
  }
}
@-webkit-keyframes kuosan1 {
  0% {
    -webkit-transform: scale(0);
    transform: scale(0);
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(1.2);
    transform: scale(1.2);
    opacity: 0;
  }
}
@keyframes kuosan1 {
  0% {
    -webkit-transform: scale(0);
    -moz-transform: scale(0);
    transform: scale(0);
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(1.2);
    -moz-transform: scale(1.2);
    transform: scale(1.2);
    opacity: 0;
  }
}
@keyframes myfirst {
  0% {
    opacity: 0.5;
  }
  20% {
    opacity: 0.6;
    transform: translateX(-30%);
  }
  40% {
    opacity: 0.7;
    transform: translateX(-20%);
  }
  80% {
    opacity: 0.9;
    transform: translateX(-10%);
  }
  100% {
    opacity: 1;
    transform: translateX(0%);
  }
}
@-webkit-keyframes myfirst {
  0% {
    opacity: 0.5;
  }
  20% {
    opacity: 0.6;
    transform: translateX(-30%);
  }
  40% {
    opacity: 0.7;
    transform: translateX(-20%);
  }
  80% {
    opacity: 0.9;
    transform: translateX(-10%);
  }
  100% {
    opacity: 1;
    transform: translateX(0%);
  }
}
@-moz-keyframes myfirst {
  0% {
    opacity: 0.5;
  }
  20% {
    opacity: 0.6;
    transform: translateX(-30%);
  }
  40% {
    opacity: 0.7;
    transform: translateX(-20%);
  }
  80% {
    opacity: 0.9;
    transform: translateX(-10%);
  }
  100% {
    opacity: 1;
    transform: translateX(0%);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Home/index.vue